<template>
  <div class="dialog-wrap">
    <el-dialog title="复试名单"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :modal-append-to-body="false"
               @open="open"
               width="80%">

      <div class="values">
        <div style="display:flex;justify-content: space-between; min-height:60px">
          <el-form class="search-wrap"
                   ref="searchForm"
                   :inline="true"
                   :model="query">
            <el-form-item label="考生姓名"
                          prop="exam_student_name">
              <el-input v-model="query.exam_student_name"
                        @input="secondaryList(true)"
                        placeholder="请输入考生姓名"></el-input>
            </el-form-item>
            <el-form-item label="考生编号"
                          prop="exam_student_no">
              <el-input v-model="query.exam_student_no"
                        @input="secondaryList(true)"
                        placeholder="请输入考生编号"></el-input>
            </el-form-item>
            <el-form-item label="年份"
                          prop="year">
              <el-select v-model="year"
                         clearable
                         style="width:90px;marginLeft:10px"
                         placeholder="请选择"
                         @change="secondaryList(true)">
                <el-option label="2027年"
                           value="2027"></el-option>
                <el-option label="2026年"
                           value="2026"></el-option>
                <el-option label="2025年"
                           value="2025"></el-option>
                <el-option label="2024年"
                           value="2024"></el-option>
                <el-option label="2023年"
                           value="2023"></el-option>
                <el-option label="2022年"
                           value="2022"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校名称"
                          prop="college_name">
              <el-select v-model="college_keyword"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         clearable
                         @change="secondaryList(true)"
                         @clear="delete_value('college_keyword')">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学院"
                          prop="reamrk">
              <el-select v-model="apply_academy"
                         placeholder="请选择院校"
                         clearable
                         filterable
                         @change="academyChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in academyList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业"
                          prop="reamrk">
              <el-select v-model="apply_major"
                         placeholder="请选择专业"
                         clearable
                         filterable
                         @change="majorChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in majorList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注"
                          prop="reamrk">
              <el-input v-model="query.remark"
                        @input="secondaryList(true)"
                        placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>

          <div style="display:flex; height:30px;">
            <div class="btBox">
              <el-button plain
                         style="marginRight:20px"
                         @click="handleDownload"
                         type="primary">下载模板</el-button>
              <input @change="upload"
                     type="file"
                     name="photoImg"
                     id="getFile"
                     style="display:none;"
                     class="upload-input" />
              <label for="getFile"
                     class="fileStyle">导入</label>
              <el-button plain
                         :loading="loading"
                         v-if="loading">导入中...</el-button>
            </div>
            <el-button class="button"
                       @click="secondarAdd"
                       type="primary">新建</el-button>

          </div>

        </div>
        <el-table class="table"
                  :data="results"
                  @selection-change="handleSelectionChange"
                  border>
          <el-table-column type="selection"
                           width="50"
                           align="center"
                           fixed="left">
          </el-table-column>
          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>

          <el-table-column prop="second_exam_college_name"
                           label="院校"
                           width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="second_exam_academy_name"
                           label="学院"
                           width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="category_ids"
                           label="专业"
                           width="200"
                           align="left">
            <template slot-scope="scope">
              ({{scope.row.second_exam_major_code}}){{scope.row.second_exam_major_name}}
            </template>
          </el-table-column>
          <el-table-column prop="exam_student_no"
                           label="考生编号"
                           width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="exam_student_name"
                           label="考生姓名"
                           width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="exam_score_politics"
                           label="科目一成绩"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.exam_score_politics">{{scope.row.exam_score_politics}}分</span>
              <span v-else>-</span> </template>
          </el-table-column>
          <el-table-column prop="exam_score_language"
                           label="科目二成绩"
                           width="100"
                           align="center"> <template slot-scope="scope">
              <span v-if="scope.row.exam_score_language">{{scope.row.exam_score_language}}分</span>
              <span v-else>-</span> </template>
          </el-table-column>
          <el-table-column prop="exam_score_business_1"
                           label="科目三成绩"
                           width="100"
                           align="center"> <template slot-scope="scope">
              <span v-if="scope.row.exam_score_business_1">{{scope.row.exam_score_business_1}}分</span>
              <span v-else>-</span> </template>
          </el-table-column>
          <el-table-column prop="exam_score_business_2"
                           label="科目四成绩"
                           width="100"
                           align="center"> <template slot-scope="scope">
              <span v-if="scope.row.exam_score_business_2">{{scope.row.exam_score_business_2}}分</span>
              <span v-else>-</span> </template>
          </el-table-column>
          <el-table-column prop="exam_score_total"
                           label="总分"
                           width="100"
                           align="center"> <template slot-scope="scope">
              <span v-if="scope.row.exam_score_total">{{scope.row.exam_score_total}}分</span>
              <span v-else>-</span> </template>

          </el-table-column>
          <el-table-column prop="remark"
                           label="备注"
                           width="200"
                           align="center">
          </el-table-column>
          <el-table-column prop="last_update_admin_nickname"
                           label="最新更新人"
                           width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="update_time"
                           label="更新时间"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.update_time).format('YYYY-MM-DD hh:mm')  }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="secondarEdit(scope.row)">编辑</el-link> |
              <el-link type="danger"
                       :underline="false"
                       @click="secondarDelele(scope.row)">删除</el-link>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="footer">
        <div>
          <el-button size="mini"
                     type="danger"
                     @click="handleToDeleteAll()">批量删除</el-button>
        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <AddSconday :visible="addVisible"
                  @close="close"
                  :detail="detail"
                  :rowId="rowId"
                  @submit="secondaryList(true)"
                  :title="title"></AddSconday>
    </el-dialog>
  </div>
</template>

<script>
import AddSconday from '@/components/dialog/admission/addSconday'
import {
  secondExamRosterList,
  secondExamRosterDelete,
  secondExamRosterlmport,
} from '@/api/admission'
import { collegeMajorList, academyList, collegeList } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    secondaryDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    year: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    secondaryDetail(val) {
      this.detail = val
      console.log('val', val)
      this.$set(this.apply_major, 'value', val.major_code)
      this.college_keyword = val.college_code
    },
  },
  components: {
    AddSconday,
  },
  data() {
    return {
      loading: false,
      title: '',
      dialogVisible: this.visible,
      addVisible: false,
      pageTotal: 10,
      detail: {},
      rowId: null,
      results: [],
      chooseList: [],
      majorList: [],
      academyList: [],
      collegeList: [],
      apply_major: { value: '', label: '' },
      apply_academy: {},
      apply_college: { value: '', label: '' },
      college_keyword: '',
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
    }
  },

  methods: {
    delete_value(value) {
      this.$delete(this.query, value)
    },
    fetchCollegeList() {
      let query = {
        pageIndex: 1,
        pageSize: 30,
      }
      collegeList(query).then((res) => {
        this.collegeList = res.list
        console.log('获取院校', res)
      })
    },
    academyChange() {
      console.log('ac', this.apply_academy)
      this.secondaryList(true)
    },
    collegeChange() {
      this.secondaryList(true)
    },
    majorChange() {
      console.log('ma', this.apply_major)
      this.secondaryList(true)
    },
    // 专业
    Majorists() {
      collegeMajorList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list
      })
    },
    // 院校
    getAcademyList() {
      academyList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.academyList = res.list
      })
    },

    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })
        secondExamRosterDelete({ ids }).then((res) => {
          this.$message.success('删除成功')
          this.secondaryList()
        })
      })
    },
    handleDownload() {
      let url =
        'https://upload.kaoyanbox.net/b448ffe4b59ebba81ca63f04e0dfcae8.xlsx'
      let filename = '复试名单文件导入示例文件.xlsx'
      var ajax = new XMLHttpRequest()
      ajax.open('GET', url, true)
      ajax.responseType = 'blob'
      ajax.onload = (e) => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type }) // 这里的res为后端返回的流数据
        if (window.navigator.msSaveOrOpenBlob) {
          //兼容IE10
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表⽰指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = filename //指定下载⽂件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      }
      ajax.send()
    },
    open() {
      this.secondaryList()
      this.Majorists()
      this.getAcademyList()
      this.fetchCollegeList()
    },
    secondaryList(reset) {
      const params = Object.assign({}, this.query)
      if (reset) {
        params.pageIndex = 1
      }
      params.year = this.year
      params.second_exam_college_code = this.college_keyword
      params.second_exam_major_code = this.apply_major.value
      params.second_exam_academy_code = this.apply_academy.value
      secondExamRosterList(params).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    close() {
      this.addVisible = false
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.secondaryList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.secondaryList()
    },
    handleClose() {
      this.apply_major = {}
      this.apply_academy = {}
      this.$emit('close')
      this.query.pageIndex = 1
    },
    handleExport() {},
    secondarEdit(row) {
      this.rowId = row.id
      this.addVisible = true
      this.title = '编辑复试名单'
    },
    secondarAdd() {
      this.addVisible = true
      this.title = '新建复试名单'
    },
    secondarDelele(row) {
      let id = {
        ids: [row.id],
      }
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定删除',
        type: 'warning',
      }).then((res) => {
        secondExamRosterDelete(id).then((res) => {
          this.$message.success('操作成功')
          this.secondaryList()
        })
      })
    },
    upload(e) {
      this.loading = true
      const file = e.target.files[0]
      console.log('filre', file)
      if (file) {
        let formData = new FormData()
        formData.append('file', file)
        secondExamRosterlmport(formData).then((res) => {
          console.log('res', res)
          if (res == null) {
            this.loading = false
            this.$message.success(`导入成功`)
            this.secondaryList(true)
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.fileStyle {
  position: relative;
  top: 0px;
  margin-right: 20px;
  border-radius: 1px;
  padding: 6px 15px;
  color: #999999;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #999999;
}
::v-deep .el-upload-list {
  display: none !important;
}
.btBox {
  position: relative;
}
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
